module.exports = __webpack_public_path__ + "img/jasrac.15be99aa.jpg";